import Radios from 'components/Formik/Radios';
import Button from 'components/Button';
import Survey from 'components/Survey';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import Email from 'blocks/Form/fields/Email';
import { Fragment } from 'react';
import Link from 'components/Link';
import UsStates from 'blocks/Form/fields/UsStates';
import { us_states } from './data';
import MultiPurposeOptIn from 'blocks/Form/fields/MultiPurposeOptIn';
import { useIdgContext } from './context/IdgContext';

const IdgSteps = ({ isPending, formik, language, initialValues }) => {
    const { increaseStep, decreaseStep, activeStep, steps } = useIdgContext();
    return (
        <div>
            {steps.map((step) => {
                return (
                    step.id === activeStep && (
                        <div key={step.id}>
                            <h3>{step.title}</h3>
                            {step.lead && <p className="lead">{step.lead}</p>}
                            <p className="mb-14">{step.description}</p>
                            {step.subTitle && (
                                <h4 className="text-maroon mb-8">
                                    {step.subTitle}
                                </h4>
                            )}
                            {step.style === 'likert' && (
                                <Survey
                                    questions={step.questions}
                                    headings={step.headings}
                                    formik={formik}
                                />
                            )}
                            {step.style === 'standard' &&
                                step.questions.map((question) => {
                                    return (
                                        <div key={question.id} className="mb-8">
                                            <h5 className="mb-4">
                                                {question.label}
                                            </h5>
                                            <Radios
                                                options={question.options}
                                                name={`q${question.id}`}
                                            />
                                        </div>
                                    );
                                })}
                            {step.style === 'submission' &&
                                step.questions.map((question) => {
                                    return (
                                        <Fragment key={question.id}>
                                            <div
                                                key={question.id}
                                                className="mb-8"
                                            >
                                                <h5 className="mb-4">
                                                    {question.label}
                                                </h5>
                                                <Radios
                                                    options={question.options}
                                                    name={`q${question.id}`}
                                                />
                                            </div>
                                            {formik.values.q14 === 'true' && (
                                                <>
                                                    <div className="grid-md-2 row-gap-0">
                                                        <FirstName
                                                            initialValues={
                                                                initialValues
                                                            }
                                                        />
                                                        <LastName
                                                            initialValues={
                                                                initialValues
                                                            }
                                                        />
                                                        <Email
                                                            initialValues={
                                                                initialValues
                                                            }
                                                        />
                                                        <UsStates
                                                            data={us_states}
                                                            initialValues={
                                                                initialValues
                                                            }
                                                        />
                                                    </div>

                                                    <MultiPurposeOptIn
                                                        initialValues={
                                                            initialValues
                                                        }
                                                        language={language}
                                                        formik={formik}
                                                    />
                                                </>
                                            )}
                                            <p className="small">
                                                * Your privacy matters. We will
                                                use your email to send you a
                                                copy of the information you saw
                                                today, as well as a reminder in
                                                2 months (if requested) to see
                                                if additional helpful
                                                information can be shared with
                                                you. By selecting the "Submit"
                                                button, you agree to the Edwards
                                                Lifesciences{' '}
                                                <Link
                                                    className={'text-grey-80'}
                                                    href="/legal/privacy-policy"
                                                >
                                                    privacy policy
                                                </Link>
                                                .
                                            </p>
                                            <p className="small">
                                                † By selecting this option, you
                                                are agreeing to receive news
                                                updates from Edwards
                                                Lifesciences. By providing your
                                                personal information, you agree
                                                to allow Edwards Lifesciences
                                                and its agents to use this
                                                information to communicate with
                                                you in the future, including
                                                information about services,
                                                events and programs. Edwards
                                                Lifesciences and its agents will
                                                not sell, rent or otherwise
                                                distribute your name and any
                                                personally identifiable
                                                information outside of Edwards
                                                Lifesciences and its agents.
                                                Edwards Lifesciences will use
                                                your information in accordance
                                                with Edwards Lifesciences{' '}
                                                <Link
                                                    className={'text-grey-80'}
                                                    href="/legal/privacy-policy"
                                                >
                                                    privacy policy
                                                </Link>
                                                .
                                            </p>
                                        </Fragment>
                                    );
                                })}
                            <div className="mt-6 survey__buttons">
                                {activeStep !== 0 && (
                                    <Button
                                        trigger={decreaseStep}
                                        className="mr-2"
                                        btn_style="ghost"
                                    >
                                        Back
                                    </Button>
                                )}
                                {step.style !== 'submission' && (
                                    <Button
                                        trigger={increaseStep}
                                        icon_position={'right'}
                                        icon="fa-solid fa-arrow-right"
                                    >
                                        {step.button}
                                    </Button>
                                )}
                                {step.style === 'submission' && (
                                    <Button type="submit" disabled={isPending}>
                                        {isPending
                                            ? 'Submitting...'
                                            : step.button}
                                    </Button>
                                )}
                            </div>
                        </div>
                    )
                );
            })}
        </div>
    );
};
export default IdgSteps;
